// extracted by mini-css-extract-plugin
export var progressContainer = "_h6-0";